module.exports = __webpack_public_path__ + "static/media/img-app-talent-profile.41851087.png";